import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';
import { SelectedEntityState } from '@shared/store/selected-entity.feature';

import { Cartographie } from '../models/cartographie.model';

export function avecSélecteursCartographies<_>() {
  return signalStoreFeature(
    {
      state: type<EntityState<Cartographie> & SelectedEntityState>(),
      props: type<EntityProps<Cartographie> & { selectedEntity: Signal<Cartographie | null> }>(),
    },
    withComputed((store) => ({
      actives: computed(() => store.entities().filter((x) => x.estActive)),
    })),
  );
}
